import React, {Component}  from 'react';
import logo from './logo.svg';
import './App.css';
import Plx from 'react-plx';
import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// Components
import Header from './components/general/header';
import Footer from './components/general/footer';
// Pages
import Home from './components/pages/home';
import Solutions from './components/pages/solutions';
import howitworks from './components/pages/howitworks';
import About from './components/pages/about';
import Blog from './components/pages/blog';
import Contact from './components/pages/contact';

// An array of parallax effects to be applied - see below for detail
const parallaxData = [
  {
    start: 0,
    end: 500,
    properties: [
      
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ],
  },
];
const parallaxData_product = [
  {
    start: 400,
    end: 500,
    properties: [
      
      {
        startValue: 1,
        endValue:.3,
        property: 'opacity',
      },
      {
        startValue: 0,
        endValue: -100,
        unit: '%',
        property: 'translateY',
      },
    ],
  },
];

const textData = [
  {
    start: '.StickyText-trigger',
    duration: '30vh',
    properties: [
      {
        startValue: 0,
        endValue: -50,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  },
  {
    start: '.StickyText-trigger',
    startOffset: '60vh',
    duration: '30vh',
    properties: [
      {
        startValue: -50,
        endValue: -100,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ],
  },
];

class App extends Component {
  render(){
      return (
        <Router>
    <div className="App">
    <StickyHeader
        // This is the sticky part of the header.
        header={<Header />}
    >
      

        <div className="app_content_container">
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/solutions" component={Solutions} />
        <Route exact path="/howitworks" component={howitworks} />
        <Route exact path="/about" component={About} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/contact" component={Contact} />
         
      </Switch>
      </div>
      <Footer/>
      </StickyHeader>
    </div>
    </Router>
  );
}
}

export default App;
